@if (status) {
  <span
    class="shipment-status"
    [style.border-color]="borderColor"
    [style.background-color]="bgColor"
    [style.color]="fontColor"
    >{{ text }}</span
  >
}
